import { CircularProgress, InputAdornment, TextField } from "@mui/material"

export const LoadingTextField = () => {
    return (
        <TextField
            variant="filled"
            disabled
            InputProps={{
                startAdornment: (
                    <InputAdornment position="start">
                        <CircularProgress size={20} color="info" />
                    </InputAdornment>
                ),
            }}
            sx={{
                width: '100%'
            }}
        />
    )
}
